module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Looking at the data on senior officers (major generals, lieutenant generals, and generals), it is surprising to find that 13 (4.4%) owned less than 20 serfs, 34 (11.5%) owned between 20 and 100 serfs, and 79 (26.8%) owned more than 100 serfs. Only 2.7% of generals possessed estates. The majority of senior officers (54.2%) had neither serfs nor property."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent82",
      "id": "theft82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd979994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof23.vue
// module id = 162
// module chunks = 0